(function () {
	'use strict';

	angular
		.module('wizard-future7')
		.controller('DefaultVideoController', DefaultVideoController)

	/** @ngInject */
	function DefaultVideoController($state, $location, $sce, HelperService) {
		const vm = this;
		let video = $state.params.video;

		vm.setSelectedVideo = videoId => vm.selectedVideo = vm.programs.find(el => el.Id == videoId)

		vm.programs = [
			{
				Id: 1,
				Video: $sce.trustAsResourceUrl('https://www.youtube.com/embed/RPX3qhgSgrU'),
				FullName: 'Financial Education',
				Url: 'financial-education'
			}, {
				Id: 2,
				Video: $sce.trustAsResourceUrl('https://www.youtube.com/embed/io_qs3dwuTk'),
				FullName: 'Emotional Intelligence',
				Url: 'emotional-intelligence'
			}, {
				Id: 3,
				Video: $sce.trustAsResourceUrl('https://www.youtube.com/embed/A3o_5hzbrvc'),
				FullName: 'Logical Thinking',
				Url: 'logical-thinking'
			}, {
				Id: 4,
				Video: $sce.trustAsResourceUrl('https://www.youtube.com/embed/QeHak3ew774'),
				FullName: 'Digital Mindset',
				Url: 'digital-mindset'
			}
		];

		init();

		function init() {
			vm.selectedVideo = vm.programs.find(el => el.Url == video || 1);

		}


	}
}());